module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "p1"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "copyright"
  }, [_c('p', {
    staticClass: "center "
  }, [_vm._v("First Mariner Books edition 2014")]), _vm._v(" "), _c('p', {
    staticClass: "center spaceabove1"
  }, [_vm._v("Copyright © 2013 by Peter Rock")]), _vm._v(" "), _c('p', {
    staticClass: "center spaceabove1"
  }, [_vm._v("All rights reserved")]), _vm._v(" "), _c('p', {
    staticClass: "center spaceabove1"
  }, [_vm._v("For information about permission to reproduce selections from this book, write to "), _c('a', {
    attrs: {
      "href": "mailto:trade.permissions@hmhco.com"
    }
  }, [_vm._v("trade.permissions@hmhco.com")]), _vm._v(" or to Permissions, Houghton Mifflin Harcourt Publishing Company, 3 Park Avenue, 19th Floor, New York, New York 10016.")]), _vm._v(" "), _c('p', {
    staticClass: "center spaceabove1"
  }, [_c('a', {
    attrs: {
      "href": "https://hmhbooks.com/",
      "target": "_blank"
    }
  }, [_vm._v("hmhbooks.com")])]), _vm._v(" "), _c('p', {
    staticClass: "center spaceabove1"
  }, [_c('em', [_vm._v("The Library of Congress has cataloged the print edition as follows:")])]), _vm._v(" "), _c('p', {
    staticClass: "center "
  }, [_vm._v("Rock, Peter, date.")]), _vm._v(" "), _c('p', {
    staticClass: "center "
  }, [_vm._v("The Shelter Cycle / Peter Rock.")]), _vm._v(" "), _c('p', {
    staticClass: "center "
  }, [_vm._v("pages cm")]), _vm._v(" "), _c('p', {
    staticClass: "center "
  }, [_vm._v("ISBN 978-0-547-85908-8    ISBN 978-0-544-28963-5 (pbk.)")]), _vm._v(" "), _c('p', {
    staticClass: "center "
  }, [_vm._v("1. Church Universal and Triumphant—Fiction. 2. Children—Montana—Fiction. 3. Self-realization—Fiction. I. Title.")]), _vm._v(" "), _c('p', {
    staticClass: "center "
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("PS")]), _vm._v("3568."), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("O")]), _vm._v("327"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("S")]), _vm._v("54 2013")]), _vm._v(" "), _c('p', {
    staticClass: "center "
  }, [_vm._v("813'.54—dc23 2012040363")]), _vm._v(" "), _c('p', {
    staticClass: "center spaceabove1"
  }, [_vm._v("eISBN 978-0-547-85911-8"), _c('br'), _vm._v("\nv3.0421")]), _vm._v(" "), _c('p', {
    staticClass: "center spaceabove1"
  }, [_vm._v("An excerpt of this book originally appeared in "), _c('em', [_vm._v("Tin House.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-133015e8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/front01.vue
// module id = 60
// module chunks = 0